export const Facebook = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2315)">
      <path
        d="M40.003 20.2239C40.003 9.10888 31.048 0.098877 20.003 0.098877C8.95298 0.101377 -0.00201416 9.10888 -0.00201416 20.2264C-0.00201416 30.2689 7.31298 38.5939 16.873 40.1039V26.0414H11.798V20.2264H16.878V15.7889C16.878 10.7464 19.8655 7.96138 24.433 7.96138C26.623 7.96138 28.9105 8.35388 28.9105 8.35388V13.3039H26.388C23.9055 13.3039 23.1305 14.8564 23.1305 16.4489V20.2239H28.6755L27.7905 26.0389H23.128V40.1014C32.688 38.5914 40.003 30.2664 40.003 20.2239Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2315">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0 0.0998535)"
        />
      </clipPath>
    </defs>
  </svg>
);
